"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.make = void 0;
// any allowed here to allow "any enum"
// eslint-disable-next-line @typescript-eslint/no-explicit-any

const make = (event, props, now = new Date(Date.now()).toISOString()) => ({
  ...event,
  timestamp: new Date(now).toISOString(),
  props
});
exports.make = make;